var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg42Covered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_84629",
    "data-name": "Group 84629",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 113.552,
    height: 126.992,
    viewBox: "0 0 113.552 126.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24662",
    "data-name": "Rectangle 24662",
    width: 113.552,
    height: 126.992,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24663",
    "data-name": "Rectangle 24663",
    width: 51.046,
    height: 51.044,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_84626",
    "data-name": "Group 84626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84625",
    "data-name": "Group 84625",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_240028",
    "data-name": "Path 240028",
    d: "M49.1,126.992a.662.662,0,0,1-.621-.438c-2.57-7.187-5.231-9.052-10.534-12.768-1.625-1.141-3.466-2.431-5.631-4.094-.635-.488-1.318-.989-2.036-1.515-5.173-3.795-12.256-8.989-18.3-21.409C4.8,72.016.884,51,0,22.523a.661.661,0,0,1,.5-.66C14.41,18.305,33.987,11.65,48.233.146A.661.661,0,0,1,49.041.13C64.636,11.738,87.719,18.953,96.919,21.518a.659.659,0,0,1,.482.686c-.056.725-.13,1.86-.213,3.158-.231,3.557-.517,7.984-.762,9.209a.66.66,0,1,1-1.294-.259c.227-1.139.523-5.7.737-9.035.067-1.017.125-1.934.174-2.635-9.512-2.679-31.908-9.8-47.38-21.15C34.444,12.81,15.213,19.421,1.336,23.01c2.072,63.819,19.374,76.51,29.724,84.1.729.533,1.417,1.04,2.061,1.535,2.142,1.644,3.971,2.927,5.585,4.057,5.083,3.564,7.84,5.5,10.357,11.67,1.8-4.182,6.68-9.447,14.541-15.69,3.834-3.043,7.936-5.939,11.555-8.493,1.9-1.336,3.686-2.6,5.164-3.695a.66.66,0,0,1,.785,1.061c-1.491,1.1-3.286,2.371-5.187,3.712-3.607,2.543-7.692,5.427-11.5,8.449-8.8,6.988-13.738,12.627-14.676,16.76a.661.661,0,0,1-.6.512l-.04,0",
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240029",
    "data-name": "Path 240029",
    d: "M45.063,108.031a.221.221,0,0,1-.181-.1c-1.32-1.9-5.641-5.659-12.84-11.182C22.454,89.4,16.056,80.28,11.9,68.065,8.239,57.279,6.185,44.03,5.032,23.764a.222.222,0,0,1,.165-.227C22.671,19.061,35.528,13.307,44.507,5.95a.222.222,0,0,1,.275-.005c9.072,7.044,25.107,11.881,34.687,14.771,2.112.637,3.939,1.188,5.256,1.635a.218.218,0,0,1,.148.232l-.055.486c-.127,1.1-.315,2.772-.315,3.195a.22.22,0,0,1-.44,0c0-.449.19-2.132.317-3.244l.035-.31c-1.3-.433-3.052-.963-5.073-1.574-9.561-2.883-25.531-7.7-34.691-14.736-8.993,7.322-21.81,13.055-39.168,17.519,2.012,35.2,6.9,57.194,26.826,72.486,6.923,5.31,11.205,9.014,12.742,11.018C46.864,104.81,55.226,97.07,61.577,92.9a.22.22,0,0,1,.3.063.223.223,0,0,1-.063.3c-6.549,4.3-15.236,12.388-16.565,14.65a.224.224,0,0,1-.181.109Z",
    transform: "translate(3.825 4.484)",
    fill: "#515255"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84628",
    "data-name": "Group 84628",
    transform: "translate(62.506 37.854)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84627",
    "data-name": "Group 84627",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_240030",
    "data-name": "Path 240030",
    d: "M58.962,26.459a4.386,4.386,0,1,0,4.386-4.386,4.387,4.387,0,0,0-4.386,4.386",
    transform: "translate(-17.687 -21.075)",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240031",
    "data-name": "Path 240031",
    d: "M40.465,44.955a4.386,4.386,0,1,1-4.386,4.386,4.387,4.387,0,0,1,4.386-4.386",
    transform: "translate(-35.081 -3.681)",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240032",
    "data-name": "Path 240032",
    d: "M63.348,44.955a4.386,4.386,0,1,0,4.386,4.386,4.387,4.387,0,0,0-4.386-4.386",
    transform: "translate(-17.687 -3.681)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240033",
    "data-name": "Path 240033",
    d: "M44.852,26.459a4.386,4.386,0,1,1-4.386-4.386,4.387,4.387,0,0,1,4.386,4.386",
    transform: "translate(-35.081 -21.075)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240034",
    "data-name": "Path 240034",
    d: "M59.027,32.96a5.044,5.044,0,0,0-9.778-.081l-3.638,8.577a5.043,5.043,0,1,0,5.272,8.595l9.463-.345a5.045,5.045,0,0,0,4.7-8.922Z",
    transform: "translate(-29.756 -15.72)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240035",
    "data-name": "Path 240035",
    d: "M56.718,31.271a5.043,5.043,0,0,0-6.159,3.506c.121.023.245.049.366.083a5.042,5.042,0,0,1,3.566,6.176l-.018.06a5.043,5.043,0,0,0,2.244-9.825",
    transform: "translate(-24.074 -14.215)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240036",
    "data-name": "Path 240036",
    d: "M43.922,37.655a5.042,5.042,0,0,0,6.116,3.58c-.042-.116-.079-.236-.113-.357A5.042,5.042,0,0,1,53.492,34.7l.062-.016a5.043,5.043,0,0,0-9.631,2.969",
    transform: "translate(-29.251 -14.057)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240037",
    "data-name": "Path 240037",
    d: "M55.89,44.958a5.044,5.044,0,0,0,.042-7.086c-.083.093-.164.187-.255.276a5.044,5.044,0,0,1-7.13,0A.561.561,0,0,0,48.5,38.1a5.043,5.043,0,0,0,7.389,6.856",
    transform: "translate(-26.567 -9.065)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240038",
    "data-name": "Path 240038",
    d: "M47.16,38.181A5.044,5.044,0,1,0,52.2,33.138a5.043,5.043,0,0,0-5.043,5.043",
    transform: "translate(-26.658 -12.664)",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240039",
    "data-name": "Path 240039",
    d: "M54.491,41.036l-.018.06a5.043,5.043,0,1,0-3.915-6.319",
    transform: "translate(-24.074 -14.215)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.133
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240040",
    "data-name": "Path 240040",
    d: "M53.492,34.7l.062-.014a5.043,5.043,0,1,0-3.515,6.549",
    transform: "translate(-29.251 -14.057)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.133
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240041",
    "data-name": "Path 240041",
    d: "M48.547,38.148,48.5,38.1a5.043,5.043,0,1,0,7.431-.231",
    transform: "translate(-26.567 -9.065)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.133
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240042",
    "data-name": "Path 240042",
    d: "M45.612,36.127a5.044,5.044,0,1,0,5.273,8.595",
    transform: "translate(-29.756 -10.392)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.133
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240043",
    "data-name": "Path 240043",
    d: "M52.891,44.666a5.044,5.044,0,0,0,4.7-8.92",
    transform: "translate(-22.301 -10.682)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.133
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240044",
    "data-name": "Path 240044",
    d: "M56.365,32.96a5.044,5.044,0,0,0-9.778-.081",
    transform: "translate(-27.093 -15.72)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.133
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240045",
    "data-name": "Path 240045",
    d: "M47.16,38.181A5.044,5.044,0,1,0,52.2,33.138,5.043,5.043,0,0,0,47.16,38.181Z",
    transform: "translate(-26.658 -12.664)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.133
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10863",
    "data-name": "Line 10863",
    transform: "translate(40.91 25.522)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.133
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10864",
    "data-name": "Line 10864",
    x1: 9.16,
    transform: "translate(1.044 25.522)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.133
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10865",
    "data-name": "Line 10865",
    y1: 5.361,
    transform: "translate(25.546 1.019)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.133
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10866",
    "data-name": "Line 10866",
    y2: 5.361,
    transform: "translate(25.546 44.664)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.133
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10867",
    "data-name": "Line 10867",
    x2: 6.007,
    y2: 6.007,
    transform: "translate(36.41 36.386)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.133
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10868",
    "data-name": "Line 10868",
    x1: 3.299,
    y1: 3.299,
    transform: "translate(8.579 8.555)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.133
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10869",
    "data-name": "Line 10869",
    y1: 5.849,
    x2: 5.849,
    transform: "translate(36.725 8.494)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.133
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10870",
    "data-name": "Line 10870",
    x1: 2.427,
    y2: 2.427,
    transform: "translate(11.077 37.563)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.133
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4915",
    "data-name": "Ellipse 4915",
    cx: 4.386,
    cy: 4.386,
    rx: 4.386,
    ry: 4.386,
    transform: "translate(41.275 0.997)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.133
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4916",
    "data-name": "Ellipse 4916",
    cx: 4.386,
    cy: 4.386,
    rx: 4.386,
    ry: 4.386,
    transform: "translate(0.998 41.274)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.133
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4917",
    "data-name": "Ellipse 4917",
    cx: 4.386,
    cy: 4.386,
    rx: 4.386,
    ry: 4.386,
    transform: "translate(41.275 41.274)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.133
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4918",
    "data-name": "Ellipse 4918",
    cx: 4.386,
    cy: 4.386,
    rx: 4.386,
    ry: 4.386,
    transform: "translate(0.999 0.997)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.133
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10871",
    "data-name": "Line 10871",
    x2: 5.15,
    transform: "translate(44.897 25.522)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.133
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10872",
    "data-name": "Line 10872",
    x1: 0.009,
    y1: 0.009,
    transform: "translate(14.688 14.664)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.133
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg42Covered);
export default __webpack_public_path__ + "static/media/4.2_Covered.20e3f8f6f2f1836fdbc4426b3f862fa8.svg";
export { ForwardRef as ReactComponent };